/**
 * What the matter's "Active Tasks" tab asks the server for.
 *
 * It used to ask for nothing in particular - no `status` at all - and
 * `/tasks/list` answers that with every non-deleted status, completed and
 * archived included. So the tab named for active work listed finished work,
 * while the Tasks page's own "active" has always meant todo + in_progress.
 *
 * `status: 'active'` closes that gap. Omitting it is what restores the old
 * everything-view, which is exactly what the "Show completed" toggle does —
 * the closed tasks are not filtered out on the client, they are simply not
 * fetched, so the toggle has to go back to the server.
 */

export const MATTER_TASK_PAGE_SIZE = 100;

export interface MatterTaskQuery {
  matter_uuid: string;
  limit: number;
  status?: string;
}

export const matterTaskQuery = (
  matterUuid: string,
  showClosed: boolean,
): MatterTaskQuery => ({
  matter_uuid: matterUuid,
  limit: MATTER_TASK_PAGE_SIZE,
  ...(showClosed ? {} : { status: 'active' }),
});
